<template>
  <div class="d-grid gap-4">
    <BaseAccordion
      v-for="(employee, employeeIndex) in formatedEmployeesData.filter((i) => i.is_extra == 0)"
      :key="'employee_' + employeeIndex"
      type="employee"
      :text="employee.employee.first_name + ' ' + employee.employee.last_name"
      :name="{ first: employee.employee.first_name, last: employee.employee.last_name }"
      :image="employee.employee.photo"
      :show="employee.employee.is_active && !employee.employee.is_deleted ? {
        name: 'timeControlShowEmployee',
        params: { employeeId: employee.employee.id },
      } : null"
    >
      <template slot="head-buttons" v-if="!employee.employee.is_active || employee.employee.is_deleted">
        <IconsUsersStatus :status="employee.employee.is_deleted ? 'deleted' : 'blocked'" class="mr-2"/>
      </template>
      <BaseTableView :head="tableHead" :class="$vuetify.breakpoint.xlOnly ? 'employee' : ''">
        <template v-for="(work, workIndex) in employee.works">
          <TimeControlShowGridEmployeeItem
            :key="'employee_' + employeeIndex + '-work_' + workIndex"
            :item="work"
            :tableHead="tableHead"
          />
        </template>
      </BaseTableView>
    </BaseAccordion>
    <div
      class="extraHeader f18 mt-4"
      :class="{ 'extraHeader--min': $vuetify.breakpoint.mdAndDown }"
      v-if="formatedEmployeesData.filter((i) => i.is_extra == 1).length"
    >
      {{ localStorage.translations.pages.statistic_project.tables['dopolnitelnye-resursy'] }}
    </div>
    <BaseAccordion
      v-for="(employee, employeeIndex) in formatedEmployeesData.filter((i) => i.is_extra == 1)"
      :key="'extra-employee_' + employeeIndex"
      type="employee"
      :text="employee.employee.first_name + ' ' + employee.employee.last_name"
      :name="{ first: employee.employee.first_name, last: employee.employee.last_name }"
      :image="employee.employee.photo"
      class="extra"
      :show="{
        name: 'timeControlShowEmployee',
        params: { employeeId: employee.employee.id },
      }"
    >
      <BaseTableView :head="tableHead">
        <template v-for="(work, workIndex) in employee.works">
          <TimeControlShowGridEmployeeItem
            :key="'extra-employee_' + employeeIndex + '-work_' + workIndex"
            :item="work"
            :tableHead="tableHead"
            :extra="true"
          />
        </template>
      </BaseTableView>
    </BaseAccordion>
  </div>
</template>

<script>
import TimeControlShowGridEmployeeItem from 'components/timeControl/show/TimeControlShowGridEmployeeItem'
import IconsUsersStatus from "components/icons/users/IconsUsersStatus.vue";

export default {
  name: 'TimeControlShowGridEmployee',
  props: ['periods'],
  components: {IconsUsersStatus, TimeControlShowGridEmployeeItem},
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages.statistic_project.tables['vid-rabot'],
        },
        {text: this.localStorage.translations.pages.statistic_project.tables['period']},
        {text: this.localStorage.translations.pages.statistic_project.tables['fakt']},
      ]
    },
    formatedEmployeesData() {
      let data = []
      for (let periodIndex in this.periods) {
        var period = this.periods[periodIndex]
        for (let employeeIndex in period.employees) {
          let employee = period.employees[employeeIndex]
          let employeeId = employeeIndex
          let obj = {}
          obj.works = []
          obj.employee = {
            first_name: employee.first_name,
            last_name: employee.last_name,
            photo: employee.photo,
            done: employee.done,
            id: employeeIndex,
            is_active: employee.is_active,
            is_deleted: employee.is_deleted,
          }
          let objWork = {}
          obj.is_extra = period.is_extra
          const checkEmployee = (obj) =>
            obj.employee.id === employeeId && obj.is_extra === period.is_extra

          if (data.findIndex(checkEmployee) === -1) {
            objWork.employee_done = employee.done
            objWork.start_date = period.start_date
            objWork.end_date = period.end_date
            objWork.end_date = period.end_date
            objWork.done = period.done
            objWork.is_extra = period.is_extra
            objWork.employees_count = period.employees_count
            objWork.left_days = period.left_days
            objWork.planned_days = period.planned_days
            objWork.planned_work = period.planned_work
            objWork.work_type = period.work_type
            obj.works.push(objWork)
            data.push(obj)
          } else {
            const checkWork = (obj) => obj.id == periodIndex
            if (data[data.findIndex(checkEmployee)].works.findIndex(checkWork) === -1) {
              let objEmployeeReady = data[data.findIndex(checkEmployee)]
              objWork.employee_done = employee.done
              objWork.start_date = period.start_date
              objWork.end_date = period.end_date
              objWork.end_date = period.end_date
              objWork.done = period.done
              objWork.is_extra = period.is_extra
              objWork.employees_count = period.employees_count
              objWork.left_days = period.left_days
              objWork.planned_days = period.planned_days
              objWork.planned_work = period.planned_work
              objWork.work_type = period.work_type
              objEmployeeReady.works.push(objWork)
            }
          }
        }
      }
      return data
    },
  },
  methods: {
    onOpenItem(id) {
      this.$router.push({
        name: 'timeControlShowEmployee',
        params: { employeeId: id },
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep().extra.base-accordion {
  .base-accordion__head {
    background: #5e5e5e;
  }
}

:deep() .extraHeader {
  display: block;
  padding: 20px 0 20px 25px;
  border-spacing: 15px;

  &--min {
    padding: 0 5px !important;
  }
}

.employee {
  :deep() td {
    &:nth-child(1) {
      width: 300px !important;
    }
    &:nth-child(2) {
      width: 150px !important;
    }
    &:nth-child(3) {
      width: 100px !important;
    }
    &:nth-child(4) {
      width: 100px !important;
    }
    &:nth-child(5) {
      width: 100px !important;
    }
  }
}
</style>
